import {useQuery} from "react-query";
import getPromise from "./getPromise";
import {ajax_url} from "../routes/TagList_Route";

const prefix_url = "/tag";

export const useTagList = ()=>{
    return useQuery(ajax_url, () => getPromise(prefix_url));
}
